import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoProviderReference = _resolveComponent("NoProviderReference")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createBlock(_component_NoProviderReference, {
        key: 0,
        "error-title": _ctx.t('payment-failed-message'),
        "error-details": ""
      }, null, 8, ["error-title"]))
    : _createCommentVNode("", true)
}